import { render, staticRenderFns } from "./JustificationChip.vue?vue&type=template&id=47146c2d"
import script from "./JustificationChip.vue?vue&type=script&lang=js"
export * from "./JustificationChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports